// ----------------------------------------------------------------------
// <copyright file="Izenda.DialogService.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!(function() {
  var DialogNode = require('./Izenda.DialogNode');
  var extendObservable = require('mobx').extendObservable;
  const { last, isNil } = require('lodash/fp');
  function DialogService() {
    this.names = [];
    extendObservable(this, {
      child: null
    });
  }

  DialogService.prototype.registerDialog = function(name, dialogType, props) {
    ensure(this.names.indexOf(name) < 0, '%s dialog already existed', name);

    var parentName = last(this.names);
    var parent = getDialogNode(this, parentName);

    this.names.push(name);
    var level = this.names.length;

    parent.child = new DialogNode(name, dialogType, level, props);
  };

  DialogService.prototype.createUnregister = function(name) {
    return function unregister() {
      var currentDialogIndex = this.names.indexOf(name);
      if (currentDialogIndex <= 0) {
        this.child = null;
      } else {
        var parent = getDialogNode(this, this.names[currentDialogIndex - 1]);
        parent.child = null;
      }
      this.names.splice(currentDialogIndex);
    }.bind(this);
  };

  DialogService.prototype.reset = function() {
    this.names = [];
    this.child = null;
  };

  function getDialogNode(node, name) {
    if (isNil(name)) {
      return node;
    }

    var current = node.child;
    while (current && current.info.name !== name) {
      current = current.child;
    }

    return current;
  }

  module.exports = DialogService;
})();



// WEBPACK FOOTER //
// ./ui/share/dialog/Izenda.DialogService.js